import type { KeyboardEvent, ReactElement } from 'react'
import React from 'react'
import { Pressable, Text, View } from 'react-native'

import * as styles from './styles'
import type { Props } from './types'

const ROLE = { radio: 'radio', checkbox: 'checkbox', noaid: 'radio' } as const

const getPressHandler = (props: Props) => props.onPress ?? props.onClick

// react-native-web presses on Enter only; radios and checkboxes also toggle on Space
const getWebOnlyProps = (props: Props, onPress: () => void) =>
  ({
    onKeyDown: (event: KeyboardEvent<HTMLDivElement>) => {
      if (event.key === ' ') {
        event.preventDefault()
        onPress()
      }
      props.onKeyDown?.(event)
    },
  }) as object

const SelectionButton = (props: Props): ReactElement => {
  const onPress = () => {
    if (props.disabled) {
      return
    }
    getPressHandler(props)?.(props.value)
  }

  const { container, textContainer, title, subtitle } = styles.selectionButton({
    hasError: props.hasError,
    noOutline: props.noOutline,
    disabled: props.disabled,
    type: props.selectType,
    selected: props.isSelected,
    variant: props.variant || 'outlined',
    size: props.size || 'default',
  })

  return (
    <Pressable
      id={props.id}
      testID={props.id}
      role={ROLE[props.selectType]}
      aria-checked={props.isSelected}
      aria-disabled={props.disabled}
      className={container()}
      style={props.style}
      onPress={onPress}
      {...getWebOnlyProps(props, onPress)}
    >
      {props.icon}
      <View className={textContainer()}>
        <Text className={title()}>{props.title}</Text>
        {props.subtitle && <Text className={subtitle()}>{props.subtitle}</Text>}
      </View>
    </Pressable>
  )
}

export default SelectionButton
